import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'date' },
  { name: 'domain' },
  { name: 'host' },
  { name: 'lang' },
  { name: 'mime' },
  { name: 'rhost' },
  { name: 'site' },
  { name: 'url' }
]

const MAX_WORDS = 40
const MAX_QUERY_LENGTH = 400

const defaultSyntaxGuideUrl = 'https://yandex.com/support/direct/keywords/symbols-and-operators.html'

class YandexEngine extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Yandex')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  formulateQuery (query) {
    return 'https://yandex.com/search/?text=' + query
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    const r = m ? [m] : []
    const q = this.formulateQueryFromTreeData(queryGraphData)
    if (q && q.split(' ').length > MAX_WORDS) {
      r.push(this.formatErrorMessage('wordAndOperatorLimit', MAX_WORDS))
    }
    if (q && q.length > MAX_QUERY_LENGTH) {
      r.push(this.formatErrorMessage('charLimit', MAX_QUERY_LENGTH))
    }
    return r
  }
}

export default YandexEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/YandexEngine.js